// extracted by mini-css-extract-plugin
module.exports = {"container":"BigFiveTestResult_container__1zU8a","info":"BigFiveTestResult_info__mPdk3"};